import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";

// ✅ Validation Schema
const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const Login = () => {
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleSubmit = async (values, { setSubmitting }) => {
    setMessage({ text: "", type: "" });

    try {
      await new Promise((resolve) => setTimeout(resolve, 1500)); // Simulated API delay
      setMessage({ text: "Login successful!", type: "success" });
    } catch (error) {
      setMessage({ text: "Invalid credentials.", type: "danger" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center "
      id="login-container"
    >
      <div
        // className="card p-4 shadow-lg"
        style={{ maxWidth: "450px", width: "100%" }}
      >
        <h3 className="text-center mb-2" id="login-title">
          Sign In
        </h3>

        {/* Success/Error Message */}
        {message.text && (
          <div
            className={`alert alert-${message.type}`}
            id={`login-message-${message.type}`}
          >
            {message.text}
          </div>
        )}

        <Formik
          initialValues={{ email: "", password: "", rememberMe: false }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form id="login-form">
              {/* Email Field */}
              <div className="mb-3">
                <label htmlFor="login-email" className="form-label">
                  Email Address *
                </label>
                <Field
                  type="email"
                  name="email"
                  id="login-email"
                  className="form-control"
                  placeholder="Enter your email"
                />
                <ErrorMessage
                  name="email"
                  component="small"
                  className="text-danger d-block mt-1"
                  id="error-login-email"
                />
              </div>

              {/* Password Field */}
              <div className="mb-3">
                <label htmlFor="login-password" className="form-label">
                  Password *
                </label>
                <Field
                  type="password"
                  name="password"
                  id="login-password"
                  className="form-control"
                  placeholder="Enter your password"
                />
                <ErrorMessage
                  name="password"
                  component="small"
                  className="text-danger d-block mt-1"
                  id="error-login-password"
                />
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="rememberMe"
                    id="login-remember-me"
                    className="form-check-input"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="login-remember-me"
                  >
                    Remember me
                  </label>
                </div>
                <Link
                  to="/forgot-password"
                  className="text-decoration-none"
                  id="login-forgot-password-link"
                >
                  Forgot password?
                </Link>
              </div>

              {/* Submit Button */}
              <div className="d-grid">
                <button
                  type="submit"
                  className="btn btn-primary"
                  id="login-submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Loading..." : "Sign In"}
                </button>
              </div>
            </Form>
          )}
        </Formik>

        {/* Register Link */}
        <p className="mt-3 text-center">
          Don't have an account?{" "}
          <Link
            to="/sign-up"
            className="text-decoration-none"
            id="login-register-link"
          >
            Register here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
